export class CurrentUserViewModel {
    exp: number = 0;
    iat: number = 0;
    nbf: number = 0;
    unique_name: string = "";
    role: string = "";
  }
  